

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as UtilityTypes from '../utilities/types'

import * as BorrowerVerificationTypes from "./types"

export type BorrowerVerificationGetAllKey = ['people',string | undefined,'verifications',unknown];

export type BorrowerVerificationGetAllResponse = BorrowerVerificationTypes.ResponseVerificationsPaging;

export type BorrowerVerificationGetAllVariables = {
    personId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
        status?: Array<string>;
    };
}

export const borrowerVerificationGetAll = makeData<
  BorrowerVerificationGetAllResponse,
  BorrowerVerificationGetAllKey,
  BorrowerVerificationGetAllVariables
>({
  method: 'get',
  name: 'borrowerVerificationGetAll',
  summary: "Get verifications",
  path: '/people/{personId}/verifications',
  queryKey: ({query, personId,}) => ['people',personId,'verifications', query],
})

export type BorrowerVerificationCreateKey = ['people',string | undefined,'verifications',unknown];

export type BorrowerVerificationCreateResponse = UtilityTypes.SingletonResponse & {
    data?: BorrowerVerificationTypes.Verification;
};

export type BorrowerVerificationCreateVariables = {
    personId: string | undefined;
    body?: BorrowerVerificationTypes.RequestBodyVerificationPost;
    query?: {
        dryRun?: boolean;
    };
}

export const borrowerVerificationCreate = makeData<
  BorrowerVerificationCreateResponse,
  BorrowerVerificationCreateKey,
  BorrowerVerificationCreateVariables
>({
  method: 'post',
  name: 'borrowerVerificationCreate',
  summary: "Start verification",
  path: '/people/{personId}/verifications',
  queryKey: ({query, personId,}) => ['people',personId,'verifications', query],
})

export type BorrowerVerificationGetKey = ['people',string | undefined,'verifications',string | undefined,unknown];

export type BorrowerVerificationGetResponse = BorrowerVerificationTypes.ResponseVerification;

export type BorrowerVerificationGetVariables = {
    personId: string | undefined;
    verificationId: string | undefined;
    body?: void;
    query?: void;
}

export const borrowerVerificationGet = makeData<
  BorrowerVerificationGetResponse,
  BorrowerVerificationGetKey,
  BorrowerVerificationGetVariables
>({
  method: 'get',
  name: 'borrowerVerificationGet',
  summary: "Get verification by ID",
  path: '/people/{personId}/verifications/{verificationId}',
  queryKey: ({query, personId,
verificationId,}) => ['people',personId,'verifications',verificationId, query],
})

export type BorrowerVerificationAnswerAttemptCreateKey = ['people',string | undefined,'verifications',string | undefined,'attempts',unknown];

export type BorrowerVerificationAnswerAttemptCreateResponse = UtilityTypes.SingletonResponse & {
    data?: BorrowerVerificationTypes.VerificationAttempt;
};

export type BorrowerVerificationAnswerAttemptCreateVariables = {
    personId: string | undefined;
    verificationId: string | undefined;
    body?: BorrowerVerificationTypes.RequestBodyVerificationAttemptPost;
    query?: void;
}

export const borrowerVerificationAnswerAttemptCreate = makeData<
  BorrowerVerificationAnswerAttemptCreateResponse,
  BorrowerVerificationAnswerAttemptCreateKey,
  BorrowerVerificationAnswerAttemptCreateVariables
>({
  method: 'post',
  name: 'borrowerVerificationAnswerAttemptCreate',
  summary: "Answer verification questions",
  path: '/people/{personId}/verifications/{verificationId}/attempts',
  queryKey: ({query, personId,
verificationId,}) => ['people',personId,'verifications',verificationId,'attempts', query],
})

export type BorrowerVerificationTypesGetAllKey = ['verification-types',unknown];

export type BorrowerVerificationTypesGetAllResponse = BorrowerVerificationTypes.ResponseVerificationTypesPaging;

export type BorrowerVerificationTypesGetAllVariables = {
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const borrowerVerificationTypesGetAll = makeData<
  BorrowerVerificationTypesGetAllResponse,
  BorrowerVerificationTypesGetAllKey,
  BorrowerVerificationTypesGetAllVariables
>({
  method: 'get',
  name: 'borrowerVerificationTypesGetAll',
  summary: "Get verification types",
  path: '/verification-types',
  queryKey: ({query, }) => ['verification-types', query],
})

export type BorrowerVerificationTypesCreateKey = ['verification-types',unknown];

export type BorrowerVerificationTypesCreateResponse = BorrowerVerificationTypes.ResponseVerificationType;

export type BorrowerVerificationTypesCreateVariables = {
    body?: BorrowerVerificationTypes.RequestBodyVerificationTypePost;
    query?: void;
}

export const borrowerVerificationTypesCreate = makeData<
  BorrowerVerificationTypesCreateResponse,
  BorrowerVerificationTypesCreateKey,
  BorrowerVerificationTypesCreateVariables
>({
  method: 'post',
  name: 'borrowerVerificationTypesCreate',
  summary: "Create verification type",
  path: '/verification-types',
  queryKey: ({query, }) => ['verification-types', query],
})

export type BorrowerVerificationTypesGetOneKey = ['verification-types',string | undefined,unknown];

export type BorrowerVerificationTypesGetOneResponse = BorrowerVerificationTypes.ResponseVerificationType;

export type BorrowerVerificationTypesGetOneVariables = {
    verificationTypeId: string | undefined;
    body?: void;
    query?: void;
}

export const borrowerVerificationTypesGetOne = makeData<
  BorrowerVerificationTypesGetOneResponse,
  BorrowerVerificationTypesGetOneKey,
  BorrowerVerificationTypesGetOneVariables
>({
  method: 'get',
  name: 'borrowerVerificationTypesGetOne',
  summary: "Get verification type by ID",
  path: '/verification-types/{verificationTypeId}',
  queryKey: ({query, verificationTypeId,}) => ['verification-types',verificationTypeId, query],
})

export type BorrowerVerificationTypesUpdateKey = ['verification-types',string | undefined,unknown];

export type BorrowerVerificationTypesUpdateResponse = BorrowerVerificationTypes.ResponseVerificationType;

export type BorrowerVerificationTypesUpdateVariables = {
    verificationTypeId: string | undefined;
    body?: BorrowerVerificationTypes.RequestBodyVerificationTypePost;
    query?: void;
}

export const borrowerVerificationTypesUpdate = makeData<
  BorrowerVerificationTypesUpdateResponse,
  BorrowerVerificationTypesUpdateKey,
  BorrowerVerificationTypesUpdateVariables
>({
  method: 'put',
  name: 'borrowerVerificationTypesUpdate',
  summary: "Update verification type",
  path: '/verification-types/{verificationTypeId}',
  queryKey: ({query, verificationTypeId,}) => ['verification-types',verificationTypeId, query],
})

export type BorrowerVerificationQuestionsGetAllKey = ['verification-questions',unknown];

export type BorrowerVerificationQuestionsGetAllResponse = BorrowerVerificationTypes.ResponseVerificationQuestionsPaging;

export type BorrowerVerificationQuestionsGetAllVariables = {
    body?: void;
    query?: void;
}

export const borrowerVerificationQuestionsGetAll = makeData<
  BorrowerVerificationQuestionsGetAllResponse,
  BorrowerVerificationQuestionsGetAllKey,
  BorrowerVerificationQuestionsGetAllVariables
>({
  method: 'get',
  name: 'borrowerVerificationQuestionsGetAll',
  summary: "Get questions",
  path: '/verification-questions',
  queryKey: ({query, }) => ['verification-questions', query],
})

export type InternalBorrowerVerificationTypesGetAllKey = ['companies',string | undefined,'verification-types',unknown];

export type InternalBorrowerVerificationTypesGetAllResponse = BorrowerVerificationTypes.ResponseVerificationTypesPaging;

export type InternalBorrowerVerificationTypesGetAllVariables = {
    companyId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const internalBorrowerVerificationTypesGetAll = makeData<
  InternalBorrowerVerificationTypesGetAllResponse,
  InternalBorrowerVerificationTypesGetAllKey,
  InternalBorrowerVerificationTypesGetAllVariables
>({
  method: 'get',
  name: 'internalBorrowerVerificationTypesGetAll',
  summary: "Get verification types",
  path: '/companies/{companyId}/verification-types',
  queryKey: ({query, companyId,}) => ['companies',companyId,'verification-types', query],
})

export type InternalBorrowerVerificationTypesCreateKey = ['companies',string | undefined,'verification-types',unknown];

export type InternalBorrowerVerificationTypesCreateResponse = BorrowerVerificationTypes.ResponseVerificationType;

export type InternalBorrowerVerificationTypesCreateVariables = {
    companyId: string | undefined;
    body?: BorrowerVerificationTypes.RequestBodyVerificationTypePost;
    query?: void;
}

export const internalBorrowerVerificationTypesCreate = makeData<
  InternalBorrowerVerificationTypesCreateResponse,
  InternalBorrowerVerificationTypesCreateKey,
  InternalBorrowerVerificationTypesCreateVariables
>({
  method: 'post',
  name: 'internalBorrowerVerificationTypesCreate',
  summary: "Create verification type",
  path: '/companies/{companyId}/verification-types',
  queryKey: ({query, companyId,}) => ['companies',companyId,'verification-types', query],
})

export type InternalBorrowerVerificationTypesGetOneKey = ['companies',string | undefined,'verification-types',string | undefined,unknown];

export type InternalBorrowerVerificationTypesGetOneResponse = BorrowerVerificationTypes.ResponseVerificationType;

export type InternalBorrowerVerificationTypesGetOneVariables = {
    companyId: string | undefined;
    verificationTypeId: string | undefined;
    body?: void;
    query?: void;
}

export const internalBorrowerVerificationTypesGetOne = makeData<
  InternalBorrowerVerificationTypesGetOneResponse,
  InternalBorrowerVerificationTypesGetOneKey,
  InternalBorrowerVerificationTypesGetOneVariables
>({
  method: 'get',
  name: 'internalBorrowerVerificationTypesGetOne',
  summary: "Get verification type by ID",
  path: '/companies/{companyId}/verification-types/{verificationTypeId}',
  queryKey: ({query, companyId,
verificationTypeId,}) => ['companies',companyId,'verification-types',verificationTypeId, query],
})

export type InternalBorrowerVerificationTypesUpdateKey = ['companies',string | undefined,'verification-types',string | undefined,unknown];

export type InternalBorrowerVerificationTypesUpdateResponse = BorrowerVerificationTypes.ResponseVerificationType;

export type InternalBorrowerVerificationTypesUpdateVariables = {
    companyId: string | undefined;
    verificationTypeId: string | undefined;
    body?: BorrowerVerificationTypes.RequestBodyVerificationTypePost;
    query?: void;
}

export const internalBorrowerVerificationTypesUpdate = makeData<
  InternalBorrowerVerificationTypesUpdateResponse,
  InternalBorrowerVerificationTypesUpdateKey,
  InternalBorrowerVerificationTypesUpdateVariables
>({
  method: 'put',
  name: 'internalBorrowerVerificationTypesUpdate',
  summary: "Update verification type",
  path: '/companies/{companyId}/verification-types/{verificationTypeId}',
  queryKey: ({query, companyId,
verificationTypeId,}) => ['companies',companyId,'verification-types',verificationTypeId, query],
})

export type InternalBorrowerVerificationQuestionsGetAllKey = ['companies',string | undefined,'verification-questions',unknown];

export type InternalBorrowerVerificationQuestionsGetAllResponse = BorrowerVerificationTypes.ResponseVerificationQuestionsPaging;

export type InternalBorrowerVerificationQuestionsGetAllVariables = {
    companyId: string | undefined;
    body?: void;
    query?: void;
}

export const internalBorrowerVerificationQuestionsGetAll = makeData<
  InternalBorrowerVerificationQuestionsGetAllResponse,
  InternalBorrowerVerificationQuestionsGetAllKey,
  InternalBorrowerVerificationQuestionsGetAllVariables
>({
  method: 'get',
  name: 'internalBorrowerVerificationQuestionsGetAll',
  summary: "Get questions",
  path: '/companies/{companyId}/verification-questions',
  queryKey: ({query, companyId,}) => ['companies',companyId,'verification-questions', query],
})
